import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TCCPCommonService } from '../../services/tccp-common.service';
import { TCCPLocalStorageService } from '../../services/tccp-local-storage.service';
import { environment } from '../../../../environments/environment';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {

  public isAccepted = false ;
  public theme = environment.applicationName;
  public org = this.theme === 'toyota' ? 'Toyota' : 'Lexus';
  constructor(
    private dialogRef: MatDialogRef<DialogComponent>, private storageService: TCCPLocalStorageService,
    private commonService: TCCPCommonService, public authService: MsalService) { }

  ngOnInit() {
    this.dialogRef.disableClose = true;
  }

  checkboxChange(isChecked) {
    if (isChecked) {
      this.isAccepted = true;
    } else {
      this.isAccepted = false;
    }
  }

  updateAuditLog() {
    const upn = this.storageService.getUpn();
    const division = this.storageService.getDivision();
    this.commonService.updateUserInfo(upn, division).subscribe(user => {
    });
  }

  onLogout() {
    this.authService.logout();
  }
}
